import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'next/link'

const StyledLink = styled(Link)`
  font-family: 'Open Sans', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  letter-spacing: inherit;
  text-decoration: inherit;
  text-transform: inherit;
  font-size: 18px;
  font-weight: 400;
  line-height: 24.55px;
  color: var(--mdc-theme-primary2);
  text-decoration: none;
`

/*
 * https://github.com/vercel/next.js/issues/1942
 */
const NextLink = ({children, href, as, prefetch, replace, scroll, shallow, locale, ...otherProps}) => (
  <StyledLink passHref href={href} as={as} prefetch={prefetch} replace={replace} scroll={scroll} shallow={shallow} locale={locale} {...otherProps}>
    {children}
  </StyledLink>
)

NextLink.propTypes = {
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  prefetch: PropTypes.bool,
  replace: PropTypes.bool,
  scroll: PropTypes.bool,
  shallow: PropTypes.bool,
  locale: PropTypes.bool,
  children: PropTypes.any
}

export {NextLink}
